import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  faHome,
  faUser,
  faUserPlus,
  faSignInAlt,
  faSignOutAlt,
  faSearch,
  faDatabase,
  faBasketShopping,
  faTrash,
  faPlus,
  faMinus,
  faAddressBook,
  faArrowRightFromBracket,
  faArrowRightToBracket,
  faPrint,
  faListCheck,
  faAddressCard,
  faGear,
  faPenToSquare,
  faShareFromSquare,
  faSquarePlus,
  faRefresh
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faHome, 
  faUser, 
  faUserPlus, 
  faSignInAlt, 
  faSignOutAlt, 
  faSearch,  
  faDatabase,
  faBasketShopping,
  faTrash,
  faPlus,
  faMinus,
  faAddressBook,
  faArrowRightFromBracket,
  faArrowRightToBracket,
  faPrint,
  faListCheck,
  faAddressCard,
  faGear,
  faPenToSquare,
  faShareFromSquare,
  faSquarePlus,
  faRefresh
  );

export { FontAwesomeIcon }; 